/* IMPORT */
import { OWNER } from '../objects/superroot.js';
import { OBSERVER } from '../context.js';
/* MAIN */
const _with = () => {
    const owner = OWNER;
    const observer = OBSERVER;
    return (fn, stack) => {
        return owner.wrap(() => fn(), owner, observer, stack);
    };
};
/* EXPORT */
export default _with;
